export const LOCAL_SERVICE_HOST = '127.0.0.1';
export const LOCAL_SERVICE_PORT = '8888';
export const LOCAL_SERVICE_PATH = '/api';
export const LOCAL_SERVICE_URL = `http://${LOCAL_SERVICE_HOST}:${LOCAL_SERVICE_PORT}${LOCAL_SERVICE_PATH}`;